import React, { FC } from 'react';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';

const AbschlussWeitere: FC<{ untertitel: string; inhalt: string }> = ({ untertitel, inhalt }) => {
	return (
		<>
			<ApplicationHeading title={untertitel} />
			<MarkdownRenderer markdown={inhalt} />
		</>
	);
};

export default AbschlussWeitere;
